// extracted by mini-css-extract-plugin
export default {"copyToClipboard":"styles_copyToClipboard__bPVAE"};